import { render } from "./IconTravel.vue?vue&type=template&id=44ae82f3"
import script from "./IconTravel.vue?vue&type=script&lang=js"
export * from "./IconTravel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__